module.exports = __webpack_public_path__ + "media/D2 Plaza 9.4a3c4e4b.mp3";